module.exports = "img/rotate-ccw.96d36a7.svg";